// extracted by mini-css-extract-plugin
module.exports = {"more":"MoreBottom-more-00f6"};